/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-01-16 14:46:56
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-03-24 17:11:31
 * @FilePath: /work.xhey.top/src/pages/components/VipPaymentModal/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import './index.scss'
import React, { useCallback, useEffect, useState } from 'react'
import { Modal, Tooltip } from 'antd'
import {
  useAppSelector,
  usePayment,
  useAppDispatch,
  useUserId,
  useVip,
  useIsPaymentV2DownloadOnceRoute
} from '../../../app/hooks'
import { fetchGoodList, fetchUpdateGoodsInfo } from '../../../actions/payment'
import { mapUpdateGoodsInfoToGoods, getPrimarySecondaryForTab } from './utils'
import { MODAL_CONFIGS, getVipLevelForTracking } from './utils/paymentConfig'
import {
  validateGoodsSelection,
  handleGoodsSelection
} from './utils/goodsValidation'
import {
  trackGoodsClick,
  trackGoodsTypeSelection,
  trackSvipRestrictionShow,
  trackConsultClick,
  trackModalClose,
  trackModalShow
} from './utils/sensorTracking'
import closeIcon from './images/btn_close_info_window.png'
import sensors from '../../../utils/sensors'
import Header from './components/Header'
import BasicPanel from './components/BasicPanel'
import AdvancedPanel from './components/AdvancedPanel'
import SuperPanel from './components/SuperPanel'
import EnterprisePanel from './components/EnterprisePanel'
import { useRef } from 'react'
import { GoodsItem } from './types'
import CONFIG from '../../../constants/config'
import paymentConfig from '../../../constants/payment'
import { useAgentCustomerDrawer } from '../../../app/hooks'
import { resolvePaymentContent } from './contentRegistry'
import type { PaymentTabKey } from './contentRegistry'

const VipPaymentModal = () => {
  const payment = usePayment()
  const group = useAppSelector((state: any) => state.group)
  const groupID = useAppSelector((state: any) => state.group.groupId)
  const userID = useUserId()
  const customerConfig = useAppSelector((state) => state.group.customerConfig)
  const [selectedGoods, setSelectedGoods] = useState<GoodsItem | null>(null)
  const [goodsList, setGoodsList] = useState<GoodsItem[]>([])
  const agentCustomerDrawer = useAgentCustomerDrawer()
  const dispatch = useAppDispatch()
  const { isVip } = useVip()
  const isPaymentV2DownloadOnceRoute = useIsPaymentV2DownloadOnceRoute()

  const allTabKeys = ['basic', 'advanced', 'super', 'enterprise']

  // 根据 paymentStatus 参数确定初始显示的 tab
  const getInitialTabKey = () => {
    const { vipKind, onlySvip, onlyVVip } = payment.paymentStatus
    // 根据 vipKind 确定默认显示的 tab
    if (vipKind === CONFIG.VIP_KIND.SVIP) {
      return 'super'
    } else if (vipKind === CONFIG.VIP_KIND.VVIP) {
      return 'advanced'
    } else if (vipKind === CONFIG.VIP_KIND.VIP) {
      return 'basic'
    } else if (vipKind === CONFIG.VIP_KIND.EVIP) {
      return 'enterprise'
    }
    // 如果指定只显示超级会员
    if (onlySvip) {
      return 'super'
    }
    // 如果指定只显示高级会员
    if (onlyVVip) {
      return 'advanced'
    }
    // 默认显示基础会员
    return 'basic'
  }

  const [currentTabKey, setCurrentTabKey] = useState<string>(getInitialTabKey())

  const tabLabels: Record<string, string> = {
    basic: '基础会员',
    advanced: '高级会员',
    super: '超级会员',
    enterprise: '企业级会员'
  }
  const tabRefs = useRef<Array<HTMLButtonElement | null>>([])

  // tab切换
  const handleTabClick = (key: string, idx: number) => {
    const { primary } = getPrimarySecondaryForTab(goodsList, key)
    // 判断该 tab 是否应当被标记为”低于团队等级”
    const rankOrder = [
      CONFIG.VIP_KIND.VIP,
      CONFIG.VIP_KIND.VVIP,
      CONFIG.VIP_KIND.SVIP,
      CONFIG.VIP_KIND.EVIP
    ]

    const isTabDisabled = (() => {
      if (!goodsList || goodsList.length === 0) return false
      if (!primary) return false
      const currentIndex = rankOrder.indexOf(group.vipInfo.vip_kind)
      const itemIndex = rankOrder.indexOf(primary.content.vipKind)
      return (
        currentIndex > -1 && itemIndex > -1 && currentIndex > itemIndex && isVip
      )
    })()

    if (isTabDisabled) return

    handleSensorClickEvent('点击上方快速切换会员等级', null, {
      string1: tabLabels[key],
      vipType: primary?.content?.vipKind,
      productID: primary?.id,
      vipLevel: getVipLevelForTracking(primary?.content?.vipKind)
    })

    // 切换 tab 自动选择该 tab 下 primary 商品
    setCurrentTabKey(key)
    if (goodsList && goodsList.length > 0) {
      if (primary && (!selectedGoods || selectedGoods.id !== primary.id)) {
        onGoodsChange(primary)
      }
    }
    const el = tabRefs.current[idx]
    if (el) el.focus()
  }

  const sourceDetail = useAppSelector(
    (state: any) => state.main.paymentStatus?.sourceDetail
  )
  const customContent = payment.paymentStatus.customContent
  const slots = resolvePaymentContent(
    customContent?.variant,
    customContent?.data
  )
  // 有 tab 小字时 tab 行变两行，需要更高的 tab 容器（否则 .vip-tabs 固定 54px +
  // overflow:hidden 会把第二行裁掉）；无小字时保持现状不影响其它来源
  const hasTabNotes = !!slots.tabNotes && Object.keys(slots.tabNotes).length > 0

  const clickInvoice = () => {
    handleSensorClickEvent('申请发票')
    window.location.href = '/orders'
  }

  const clickAllRights = () => {
    handleSensorClickEvent('查看全部权益')
    window.location.href = `/privileges?fromPlace=${encodeURIComponent(
      '开通页'
    )}`
  }

  // 当 paymentStatus 改变时，重新设置初始 tab
  useEffect(() => {
    if (payment.paymentStatus.visible) {
      setCurrentTabKey(getInitialTabKey())
    }
  }, [
    payment.paymentStatus.visible,
    payment.paymentStatus.vipKind,
    payment.paymentStatus.onlySvip,
    payment.paymentStatus.onlyVVip
  ])

  useEffect(() => {
    if (payment.paymentStatus.visible && group.photo_agg_type) {
      sensors.track('web_get_action_workgroup_buy_customer_vip_tips', {
        groupID,
        actionType: 'showPop'
      })
      Modal.info({
        ...MODAL_CONFIGS.CUSTOMER_TIPS,
        content: (
          <>
            <p style={{ marginBottom: '0.5em' }}>
              您的团队正在使用{customerConfig.noun}
              {customerConfig.verb}功能
            </p>
            <p>建议在手机上购买该功能的专属会员</p>
          </>
        ),
        onOk: () => {
          sensors.track('web_get_action_workgroup_buy_customer_vip_tips', {
            groupID,
            actionType: 'clickKnow'
          })
        }
      })
    }
  }, [payment.paymentStatus.visible, group.photo_agg_type, groupID])

  useEffect(() => {
    if (payment.paymentStatus.visible && groupID) {
      trackModalShow(sourceDetail)
      dispatch(
        fetchGoodList({
          groupID,
          userID
        })
      )
        .then((data: any) => {
          if (data && data.status === 0 && data.goods) {
            let updatedGoodsList = [...data.goods]
            dispatch(
              fetchUpdateGoodsInfo({
                groupID
              })
            )
              .then((updateData: any) => {
                const mapped = mapUpdateGoodsInfoToGoods(updateData)
                if (mapped && mapped.length > 0) {
                  updatedGoodsList = [...mapped, ...updatedGoodsList]
                }
                setGoodsList(updatedGoodsList)
                const initialTabForStatus = getInitialTabKey()
                const { primary } = getPrimarySecondaryForTab(
                  updatedGoodsList,
                  initialTabForStatus
                )
                if (primary) {
                  setSelectedGoods(primary)
                } else {
                  setSelectedGoods(null)
                }
              })
              .catch(() => {
                setGoodsList(updatedGoodsList)
                setSelectedGoods(null)
              })
          }
        })
        .catch(() => {
          /* noop */
        })
    }
  }, [
    payment.paymentStatus.visible,
    group.photo_agg_type,
    groupID,
    userID,
    dispatch
  ])

  const handleSensorClickEvent = useCallback(
    (clickItem: string, goods: any = null, params: any = {}) => {
      trackGoodsClick(
        clickItem,
        goods || selectedGoods,
        groupID,
        sourceDetail,
        payment.paymentStatus.isFromToView,
        params
      )
    },
    [groupID, selectedGoods, payment, sourceDetail]
  )

  const { svipOnlyText } = paymentConfig

  const onGoodsChange = useCallback(
    (item: GoodsItem) => {
      // 埋点统计
      trackGoodsTypeSelection(
        item,
        groupID,
        sourceDetail,
        payment.paymentStatus.isFromToView,
        { vipType: item?.content?.vipKind }
      )

      // 商品选择验证和处理
      const validation = validateGoodsSelection(
        item,
        payment.paymentStatus,
        sourceDetail,
        svipOnlyText
      )

      if (!validation.allowed && validation.type === 'svip') {
        trackSvipRestrictionShow(sourceDetail)
      }

      handleGoodsSelection(
        item,
        validation,
        payment.paymentStatus,
        sourceDetail,
        svipOnlyText,
        setSelectedGoods
      )
    },
    [
      payment.paymentStatus,
      sourceDetail,
      groupID,
      svipOnlyText,
      setSelectedGoods
    ]
  )

  const handleClose = useCallback((isSensor = false) => {
    if (isSensor) {
      trackModalClose(sourceDetail)
    }
    payment.close()
  }, [])

  /**
   * 开通团队会员弹窗
   * */
  const paymentGroupContent = () => {
    return (
      <div className="vip-modal-body">
        <div className="vip-modal-header">
          <Header
            groupName={group.groupName}
            avatarUrl={group.avatar}
            color={group.color}
            title={slots.title}
            subtitle={slots.subtitle}
            onConsult={() => {
              trackConsultClick(sourceDetail)
              agentCustomerDrawer.open({ from: 'vip_modal' })
            }}
            className={currentTabKey === 'super' ? 'svip' : 'vip'}
          />
        </div>

        <div className="vip-modal-content">
          <div
            className={`vip-tabs ${currentTabKey === 'super' ? 'svip' : 'vip'}${
              hasTabNotes ? ' has-notes' : ''
            }`}
          >
            <div role="tablist" className="vip-tab-list">
              {allTabKeys.map((key, idx) => {
                const { primary } =
                  goodsList && goodsList.length > 0
                    ? getPrimarySecondaryForTab(goodsList, key)
                    : { primary: null }
                const KIND_WEIGHTS: Record<number, number> = {
                  [CONFIG.VIP_KIND.VIP]: 1,
                  [CONFIG.VIP_KIND.VVIP]: 2,
                  [CONFIG.VIP_KIND.SVIP]: 3,
                  [CONFIG.VIP_KIND.EVIP]: 4
                }
                const currentWeight = primary
                  ? KIND_WEIGHTS[group.vipInfo.vip_kind] || 0
                  : 0
                const itemWeight = primary
                  ? KIND_WEIGHTS[primary.content.vipKind] || 0
                  : 0
                const isDisabled =
                  !!primary &&
                  isVip &&
                  currentWeight > 0 &&
                  itemWeight > 0 &&
                  currentWeight > itemWeight

                return (
                  <button
                    key={key}
                    role="tab"
                    aria-selected={currentTabKey === key}
                    tabIndex={currentTabKey === key ? 0 : -1}
                    ref={(el) => (tabRefs.current[idx] = el)}
                    className={`tab-item ${
                      currentTabKey === key ? 'active' : ''
                    } ${isDisabled ? 'disabled' : ''}`}
                    onClick={() => handleTabClick(key, idx)}
                  >
                    {isDisabled ? (
                      <Tooltip
                        title="低于当前等级，暂不支持购买"
                        placement="top"
                      >
                        <span className="tab-label">{tabLabels[key]}</span>
                      </Tooltip>
                    ) : (
                      <span className="tab-label">{tabLabels[key]}</span>
                    )}
                    {slots.tabNotes?.[key as PaymentTabKey] && (
                      <span className="tab-note">
                        {slots.tabNotes[key as PaymentTabKey]}
                      </span>
                    )}
                  </button>
                )
              })}
            </div>
          </div>

          <div className="vip-tab-panel">
            {currentTabKey === 'basic' && (
              <BasicPanel
                key="basic"
                cardBanner={slots.cardBanner?.basic}
                goodsList={goodsList}
                selectedGoods={selectedGoods}
                onSelect={onGoodsChange}
                onBuy={() => handleSensorClickEvent('clickBuy', selectedGoods)}
                sensorClickEvent={handleSensorClickEvent}
                onClose={() => handleClose(false)}
                clickInvoice={clickInvoice}
                clickAllRights={clickAllRights}
                onConsult={() => {
                  trackConsultClick(sourceDetail)
                  agentCustomerDrawer.open({ from: 'vip_modal' })
                }}
              />
            )}
            {currentTabKey === 'advanced' && (
              <AdvancedPanel
                key="advanced"
                cardBanner={slots.cardBanner?.advanced}
                goodsList={goodsList}
                selectedGoods={selectedGoods}
                onSelect={onGoodsChange}
                onClose={() => handleClose(false)}
                clickInvoice={clickInvoice}
                clickAllRights={clickAllRights}
                onConsult={() => {
                  trackConsultClick(sourceDetail)
                  agentCustomerDrawer.open({ from: 'vip_modal' })
                }}
              />
            )}
            {currentTabKey === 'super' && (
              <SuperPanel
                key="super"
                cardBanner={slots.cardBanner?.super}
                goodsList={goodsList}
                selectedGoods={selectedGoods}
                onSelect={onGoodsChange}
                onBuy={() => handleSensorClickEvent('clickBuy', selectedGoods)}
                onClose={() => handleClose(false)}
                clickInvoice={clickInvoice}
                clickAllRights={clickAllRights}
                onConsult={() => {
                  trackConsultClick(sourceDetail)
                  agentCustomerDrawer.open({ from: 'vip_modal' })
                }}
              />
            )}
            {currentTabKey === 'enterprise' && (
              <EnterprisePanel
                key="enterprise"
                cardBanner={slots.cardBanner?.enterprise}
                selectedGoods={selectedGoods}
                onBuy={() => handleSensorClickEvent('clickBuy')}
              />
            )}
          </div>
        </div>
      </div>
    )
  }

  if (!payment.paymentStatus.visible) {
    return null
  }

  if (isPaymentV2DownloadOnceRoute) {
    return null
  }

  return (
    <div className="payment-refactor">
      <div className="payment-modal">
        <div className="closeIconDiv">
          <img src={closeIcon} onClick={() => handleClose(true)} />
        </div>
        <div className="modal-content">{paymentGroupContent()}</div>
      </div>
    </div>
  )
}

export default VipPaymentModal
